










































































































import VueOptions from '@utils/VueOptions'
import Trigger from '@modules/ui/triggers/Trigger'
import Carousel from '@ui/Carousel'

settings = 
  name: 'OfferDetails'
  vue:
    props: ['offer', 'step']

    components: { Trigger, Carousel }
    
    data: ->
      openPanel: null

      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      isProductSampling: ->
        return @offer.activation_snapshot_space_names[0] == 'Product Sampling'
      activations: -> (act for name, act of @offer?.activation_snapshots)
      activation: -> @activations?[0]
      brandInfo: -> @activation?.brand_info || {}
      brandName: -> @ctxBrand(@offer).name

      hasBoothActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['booth']
        has
      hasFoodTruckActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['foodtruck', 'food_truck', 'food truck']
        has
      hasTrailerActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['truck', 'trailer']
        has
      hasSamplingActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['sampl']
        has
      shouldShowActivationName: ->  @activation.name? and @activation.name isnt @ctxSponsorOrg(@offer).name

      memberNoteTriggerResource: ->
        { key: 'offer', triggerName: 'add_member_note', component: @$parent.$parent }
      superNoteTriggerResource: ->
        { key: 'offer', triggerName: 'add_super_note', component: @$parent.$parent }

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload
      dayExpiresAt: -> dayjs(@offer.expires_at).add(1, 'day')
      isExpired: ->  not @dayExpiresAt.isAfter(dayjs())

      carouselImages: -> @ctxCampaign(@offer).images?.map((image) -> image.url) || []

      shippingPlan: ->
        lineItem = @offer.purchase_order_line_items[0]
        lineItem.shipping_plan
      selectedShippingPlan: ->
        @shippingPlan[@shippingPlan.type]
      shipments: ->
        @selectedShippingPlan?.shipments || []

    methods:
      variables: (lineItem) ->
        vars = lineItem.variable_settings || {}
        vars[name] = value for name, value of lineItem.variables
        vars

export default VueOptions.vue settings
